(function(angular, schoolwork12) {
    'use strict';
    
    angular.module(schoolwork12.app.student.name)
        .controller(schoolwork12.app.student.controllers.studentBySubject, 
        ['$rootScope', '$scope', '$http', '$location', '$state', '$uibModal', '$filter','graduationPlanSvc',
        schoolwork12.app.auth.services.authentication,
        schoolwork12.app.common.services.utilService,

                function($rootScope, $scope, $http, $location, $state, $uibModal, $filter,graduationPlanSvc, authentication, utilService) {
                console.info('calling student grad plan Controller- by Subject View:......');
                    $scope.bySubjectView = true;
                    $scope.stuGradPlanBySubSuccess = false;
                    $scope.isStuGradPlanSubSpinnerActive = false;
                    $scope.validateCoursesNoC = false;
                    $scope.validateSubjects = false;
                    $scope.editGradBySubjectErrorOccurred = false;
                    $scope.validationList=[];
                    var editedCourseList = []; //map of the edited courses
                    $scope.editSubjectView = false;
                    $scope.editModeSubject = function(){
                        $scope.editSubjectView = graduationPlanSvc.editSubjectView;
                        return $scope.editSubjectView;
                    };
                    $scope.subjectFields2 = angular.copy(graduationPlanSvc.subjectFields);
                    $scope.stuGradPlanBySubjectAccordions = { creditSummary: true, creditSummaryEdit:false, notCounted: true, addRequirements: true, opened: true };
                    
                    $scope.$watch('editSubjectView', function() {
                       if($scope.editSubjectView == true) {
                         $scope.getStudentGradPlanBySubject();
                       }
                    });
                    
                    $scope.initializeSubjectView = function(){
                            editedCourseList = [];
                        if(!$scope.yearViewClicked || $scope.savePlanSuccess){
                             $scope.getStudentGradPlanBySubject();
                        } 
                    }
                    
                    var currentStudent = angular.copy($scope.studentRow.entity); 

                    //close success msg on click
                    $scope.closeStudentBySubMsg = function() {
                        $scope.showSavedStudentMsg = false;
                    }
                    //invoke by subject service 
                    $scope.getStudentGradPlanBySubject = function(){
                        console.log("Getting Grad Plan by Subject view");
                          $scope.isStuGradPlanSubSpinnerActive = true;
                        $http({
                            url: schoolwork12.app.student.endpoints.studentEdit + $scope.studentRow.entity.studentId + '/gradplanBySubject/school/' + $scope.studentRow.entity.schoolId,  
                            method : "GET",
                            headers : {
                                        'X-API-TOKEN': authentication.getCurrentUser().keycode,
                                    }
                        }).then(function(response){                        
                            console.info("Viewing student graduation plan by Subject");
                            $scope.isStuGradPlanSubSpinnerActive = false;
                            if(!(angular.isDefined(response.data.stuGradPlanBySubject)))
                            	{
                            	$scope.stuGradPlanBySubSuccess = false;
                            	}
                            else{
                            	 $scope.stuGradPlanBySubSuccess = true;
                                 $scope.editGradBySubjectErrorOccurred = false;
                            	 $scope.stuGPBySub = response.data.stuGradPlanBySubject;
                            	 $scope.buildSubjectView();
                                 $scope.forms.Subjects.$setPristine();
                                 $scope.forms.CoursesNotCounted.$setPristine();
                                 $scope.forms.postHSSubject.$setPristine();
                                 $scope.editStudent.lastModifiedDate=response.data.stuGradPlanBySubject.lastModifiedDate;
                                 $scope.postHSSubjectData = { selectedHSPlan: response.data.stuGradPlanBySubject.postHsPlansId, text: response.data.stuGradPlanBySubject.postHsPlansDetails };
                                 $scope.onChangeHSPlanSubject();
                                 $scope.postHSSubjectSnap = {...$scope.postHSSubjectData};
                            }
                            //$scope.$parent.stuGPBySubData = true;
                            // $scope.stuGPBySubData = true;

                        }, function(error){
                            console.info('Error in viewing student graduation plan by Subject...'.concat(angular.toJson(error)));
                            $scope.stuGradPlanBySubSuccess = false;
                            $scope.isStuGradPlanSubSpinnerActive = false;
                            $scope.editGradBySubjectErrorOccurred = true;
                            $scope.getGradSubErrorMesg = "";
                            if (error.status == 400) {
                                $scope.stuGradPlanSuccess = false;
                                for (var j = 0; j < error.data._errors.length; j++) {
                                    $scope.getGradSubErrorMesg = $scope.getGradSubErrorMesg + error.data._errors[j] + "\n";
                                }
                            } else if (error.status == 401 || error.status == 403) {
                                $scope.getGradSubErrorMesg = schoolwork12.app.errorMessages.sessionExpired;
                            } else {
                                $scope.getGradSubErrorMesg = schoolwork12.app.errorMessages.internalError;
                            }    
                        })
                    }
                   

                    $scope.buildSubjectView = function(){
                        console.log($scope.readyForStudentViewDisplay.valueEdit);

                        console.log("Building subject view");
                        initializeFormValidations();
                        
                        if(!(angular.isDefined($scope.stuGPBySub.totalCreditsEarnedForSubjectsNotOnDiploma)))
                            $scope.stuGPBySub.totalCreditsEarnedForSubjectsNotOnDiploma='--';
                        if(!(angular.isDefined($scope.stuGPBySub.totalCreditsInProgressForSubjectsNotOnDiploma)))
                            $scope.stuGPBySub.totalCreditsInProgressForSubjectsNotOnDiploma='--';
                        if(!(angular.isDefined($scope.stuGPBySub.totalCreditsNotStartedForSubjectsNotOnDiploma)))
                            $scope.stuGPBySub.totalCreditsNotStartedForSubjectsNotOnDiploma='--';
                     
                        // build subjectsList
                        $scope.subjectList = [];
                        angular.forEach($scope.stuGPBySub.subjectsDetails, function(subject){
                            subject.subjectName = $scope.subjectNameFromMap(subject.schoolSubjectId, subject.k12SubjectId);
                            subject.open = true;

                            subject.creditsEarned = angular.isDefined(subject.creditsEarned) ? subject.creditsEarned : 0;
                            subject.creditsRequired = angular.isDefined(subject.creditsRequired) ? subject.creditsRequired : 0;
                            subject.creditsInprogress = angular.isDefined(subject.creditsInprogress) ? subject.creditsInprogress : 0;
                            subject.creditsNotStarted = angular.isDefined(subject.creditsNotStarted) ? subject.creditsNotStarted : 0;
                            subject.creditsNotCounted = angular.isDefined(subject.creditsNotCounted) ? subject.creditsNotCounted : 0;
                    
                            if(angular.isDefined(subject.subSubjects)){
                                angular.forEach(subject.subSubjects, function(subSubject){
                                    subSubject.subjectName = $scope.subjectNameFromMap(subSubject.schoolSubjectId,subSubject.k12SubjectId); 
                                    subSubject.creditsEarned = angular.isDefined(subSubject.creditsEarned) ? subSubject.creditsEarned : 0;
                                    subSubject.creditsRequired = angular.isDefined(subSubject.creditsRequired) ? subSubject.creditsRequired : 0;
                                    subSubject.creditsInprogress = angular.isDefined(subSubject.creditsInprogress) ? subSubject.creditsInprogress : 0;
                                    subSubject.creditsNotStarted = angular.isDefined(subSubject.creditsNotStarted) ? subSubject.creditsNotStarted : 0;
                                    subSubject.creditsNotCounted = angular.isDefined(subSubject.creditsNotCounted) ? subSubject.creditsNotCounted : 0;
                                    angular.forEach(subSubject.stuGPCourse, function(course){
                                       course.subjectName = subSubject.subjectName;
                                       course.subject =   subSubject.schoolSubjectId ;
                                       course.k12SubjectId = subSubject.k12SubjectId ;
                                       if(course.isNonK12Course == 1)
                                    	{
                                    	   course.courseName = course.nonK12CourseName;
                                    	   }
                                       else
                                    	{
                                    	   course.courseName = $scope.courseDisplay(course); 
                                    		   }
                                      
                                       course.credits = $scope.creditsDisplay(course);
                                       getGradefromStatus(course);
                                       course.showDagger = course.doNotIncludeInCreditTotals == 1 || course.subjectNotOnDiploma == 1 ? true : false;
                                       course.showAstrick = course.completionStatusId == 0 || course.completionStatusId == 1 ? true : false;
                                    });
                                });
                            } else {
                                angular.forEach(subject.stuGPCourse, function(course){
                                    course.subjectName = subject.subjectName;
                                    course.subject =  subject.schoolSubjectId ;
                                    course.k12SubjectId = subject.k12SubjectId ;
                                    if(course.isNonK12Course == 1)
                                	{ course.courseName = course.nonK12CourseName;
                                	   }
                                   else
                                	{ course.courseName = $scope.courseDisplay(course); } 
                                    course.credits = $scope.creditsDisplay(course);
                                    getGradefromStatus(course);
                                    course.showDagger = course.doNotIncludeInCreditTotals == 1 || course.subjectNotOnDiploma == 1 ? true : false;
                                    course.showAstrick = course.completionStatusId == 0 || course.completionStatusId == 1 ? true : false;
                                
                                }); 
                            }
                            $scope.subjectList.push(subject);
                        });

                        //Sort the hierarchial structure for subjectlist
                        // For each subject in subject list 
                        angular.forEach($scope.subjectList, function(subject){                            
                            // If subsubjects are present                           
                            if(angular.isDefined(subject.subSubjects)){                                
                                angular.forEach(subject.subSubjects , function(subSubject){
                                   //sort courses for each sub-subject
                                   if(angular.isDefined(subSubject.stuGPCourse && subSubject.stuGPCourse.length > 1)){
                                        subSubject.stuGPCourse.sort(courseSort);    
                                   } 
                                });
                                //sort sub-subjects alphabetically in each subject
                                subject.subSubjects.sort(sortSubject);
                            // If no sub-subjects are present and subject has courses                                
                            } else if(angular.isDefined(subject.stuGPCourse)){
                                //sort courses in subject
                                subject.stuGPCourse.sort(courseSort);
                            }                           
                        });
                        // sort list of subjects alphabetically in subject list
                        // sample using _.js
                        $scope.subjectList = _.sortBy($scope.subjectList, 'subjectName');

                        // build subjectsNotOnDiploma
                        $scope.subjectsNotOnDiploma = [];
                        angular.forEach($scope.stuGPBySub.subjectsNotOnDiploma, function(subject){
                            var subjectName = $scope.subjectNameFromMap(subject.schoolSubjectId, subject.k12SubjectId);
                             subject.subjectName = subjectName;
                            angular.forEach(subject.stuGPCourse, function(course){
                                var subcourse = {subjectName : subjectName};
                                course.subject =  subject.schoolSubjectId ;
                                course.subjectName = subject.subjectName ;
                                course.k12SubjectId = subject.k12SubjectId ;
                                if(course.isNonK12Course == 1)
                            	{ course.courseName = course.nonK12CourseName;
                            	   }
                               else
                            	{  course.courseName = $scope.courseDisplay(course); 
                            		   }
                                course.credits = $scope.creditsDisplay(course);
                                getGradefromStatus(course);
                                course.showDagger = course.doNotIncludeInCreditTotals == 1 || course.subjectNotOnDiploma == 1 ? true : false;
                                course.showAstrick = course.completionStatusId == 0 || course.completionStatusId == 1 ? true : false;
                                angular.extend(subcourse, course);
                                $scope.subjectsNotOnDiploma.push(subcourse);
                            });
                        });
                        
                        $scope.subjectsNotOnDiploma.sort(sortSubject);

                        //create snapshots
                       
                       $scope.subjectListSnapShot= angular.copy($scope.subjectList );
                       $scope.subjectsNotOnDiplomaSnapshot= angular.copy($scope.subjectsNotOnDiploma );

                    }

                    //initialize controller and load subject view
                    $scope.initializeSubjectView();
            
                    $scope.cancelGradPlanEditBySubject = function(){
                      $scope.showSavedStudentMsg = false;
                      $scope.toggleMove = false;
                      var resetEditView = false;
                      if($scope.forms.CoursesNotCounted.$dirty || $scope.forms.Subjects.$dirty || $scope.forms.postHSSubject.$dirty){

                            if(!$scope.option2){
                                    $scope.openAlertUnsavedSub();
                            }
                            $scope.modalInstance3.result.then(function (option) {
                                $scope.option2 = option;
                                 resetEditView = option ? false : true;
                                graduationPlanSvc.editSubjectView = option ? false : true;
                                if(option){
                                    $scope.subjectsNotOnDiploma= angular.copy ($scope.subjectsNotOnDiplomaSnapshot) ;
                                    $scope.subjectList= angular.copy ($scope.subjectListSnapShot) ;
                                    $scope.postHSSubjectData = {...$scope.postHSSubjectSnap};

                                    $scope.option2=false;
                                    initializeFormValidations();
                                    editedCourseList = [];
                                    $scope.forms.CoursesNotCounted.$setPristine();
                                    $scope.forms.Subjects.$setPristine();
                                    $scope.forms.postHSSubject.$setPristine();
                                    $scope.disableEditMode();
                                }
                            });  
                      }else {
                        resetEditView = true;
                      } 
                      if(resetEditView) $scope.cancelGradPlanEdit();

                    }

                    $scope.deleteCourseSubject = function( i , j, k){
                       var updatedCourse = {};
                       updatedCourse = createUpdatedCourse( $scope.subjectList[j].stuGPCourse[k]);
                       updatedCourse.status = 0;
                       editedCourseList[ $scope.subjectList[j].stuGPCourse[k].id]=updatedCourse;
                       $scope.subjectList[j].stuGPCourse.splice(k,1);
                       $scope.forms.Subjects.$setDirty();
                    }

                    $scope.deleteCourseSubSubject = function( schoolSubjectId ,i, j, k){

                       var updatedCourse = {};
                       updatedCourse = createUpdatedCourse( $scope.subjectList[i].subSubjects[j].stuGPCourse[k]);
                       updatedCourse.status = 0;
                       editedCourseList[$scope.subjectList[i].subSubjects[j].stuGPCourse[k].id]=updatedCourse;
                       $scope.subjectList[i].subSubjects[j].stuGPCourse.splice(k,1);
                       $scope.forms.Subjects.$setDirty();
                    }
                   // var CourseNotCountedDeletedList = [];
                    $scope.deleteCourseNotCounted = function( i ){
                       var updatedCourse = {};
                       updatedCourse = createUpdatedCourse( $scope.subjectsNotOnDiploma[i]);
                       updatedCourse.status = 0;
                       editedCourseList[$scope.subjectsNotOnDiploma[i].id]=updatedCourse;
                       $scope.subjectsNotOnDiploma.splice(i, 1);
                       $scope.forms.CoursesNotCounted.$setDirty();
                    }

                    $scope.changeSubjectNotOnDiplima = function(course, i  ){
                        var updatedCourse = {};
                        updatedCourse = createUpdatedCourse(course);
                        editedCourseList[course.id]=updatedCourse;
                        $scope.forms.CoursesNotCounted.$setDirty();
                    }

                     $scope.changeCourse = function(course){
                        var updatedCourse = {};
                        updatedCourse = createUpdatedCourse(course);
                        editedCourseList[course.id]=updatedCourse;
                        $scope.forms.Subjects.$setDirty();
                     }

                    var createUpdatedCourse = function(course){
                        var updatedCourse = {};
                        updatedCourse.stuGPCourseID = course.id;
                        updatedCourse.schoolSubjectId =  graduationPlanSvc.mapSchoolSubjectIds[ course.subjectName];
                        updatedCourse.k12SubjectId = graduationPlanSvc.mapK12SubjectIds[ course.subjectName];
                        updatedCourse.status = 1;
                        return updatedCourse;
                    }; 

                    $scope.openAlertUnsavedSub = function () {
                        $scope.modalInstance3 = $uibModal.open({
                            animation: $scope.animationsEnabled,
                            templateUrl: 'commonDialog.html',
                            keyboard: false,
                            backdrop: 'static',
                            windowClass: 'alert-Modal',
                            scope: $scope,
                            controller: ['$scope', '$uibModalInstance',
                            function ($scope, $uibModalInstance) {
                                $scope.ok = function () {
                                    $uibModalInstance.close(true);
                                };
                                $scope.dialogMsg = 'You have un-saved changes for the current student. Do you want to continue without saving the changes?';
                                $scope.cancel = function () {
                                    $uibModalInstance.dismiss('cancel');
                                    $rootScope.hideStudentSearch = true;
                                    //if no option is selected from modal
                                    if(!$scope.studentedited){
                                        var index=-1;
                                        for(var i=0; i< $scope.gridNewOptions.data.length; i++){
                                            if($scope.gridNewOptions.data[i].studentId==currentStudent.studentId){
                                                index=i;
                                                $scope.gridNewApi.selection.selectRow($scope.gridNewOptions.data[i]);
                                                break;
                                            }
                                        }
                                    }
                                };
                            }],
                        });
                        $scope.$parent.$parent.hideStudentDetails = true;
                        $rootScope.$emit('hideStudentDetails',{});
                    };

                    $rootScope.$on('$stateChangeStart', function(event, next, current) { 
                      // $scope.searchTab = false;  
                      $scope.stuGradPlanBySubjectEdited = false;
                        
                            if($scope.forms.CoursesNotCounted.$dirty || $scope.forms.Subjects.$dirty || $scope.forms.postHSSubject.$dirty){
                                $scope.stuGradPlanBySubjectEdited = true;
                                if(!$scope.option2){
                                    $scope.openAlertUnsavedSub();
                                    event.preventDefault(); 
                                }                               
                                
                                $scope.modalInstance3.result.then(function (option) {
                                    $scope.option2 = option;

                                    if((next.url == '/student-details') && $scope.stuGradPlanBySubjectEdited) { 
                                        $scope.$parent.$parent.hideStudentDetails = false;
                                        $rootScope.hideStudentSearch = true;

                                        //get current student entity row : gradplan edited                                      
                                        $scope.getStudentInfo();
                                        $location.url('/student-search/student-details');
                                        
                                    } else if(next.url == '/student-graduation-plan'){
                                        $scope.toggleYearView ();
                                        $rootScope.hideStudentSearch = true;
                                        editedCourseList = [];
                                        $scope.getStudentGradPlanBySubject();
                                        $scope.getStudentGradPlan();
                                        $scope.cancelGradPlanEdit();
                                        $scope.option2 = false;
                                        $location.url('/student-search/student-details/student-graduation-plan');
                                        $scope.postHSSubjectData = {...$scope.postHSSubjectSnap};

                                    } else if(next.url == '/cre-tracking'){
                                        $location.url('/student-search/student-details/cre-tracking');
                                    }
                                     
                                    else{
                                        $location.url(next.url); 
                                    }
                                });
                            }
                        
    
                        if((next.url == '/student-details') && !$scope.stuGradPlanBySubjectEdited){
                            $scope.$parent.$parent.hideStudentDetails = false;
                            $rootScope.hideStudentSearch = true;

                            //get current student entity row : gradplan not edited  
                            if($scope.gradPlanState && !$scope.isSaveStuPlanBusy){
                                if(!$scope.searchRevisited){
                                    $scope.getStudentInfo();
                                }
                               
                            }                            
                        }
                            
                    })

                    $scope.isSaveSubjectEnabled = ()=> {
                        return $scope.forms.CoursesNotCounted.$dirty || $scope.forms.Subjects.$dirty || $scope.forms.postHSSubject.$dirty
                    }

                    $scope.saveGradPlanEditBySubject = function (){
                        if ($scope.forms.CoursesNotCounted.$dirty){
                            var index = 0;
                             angular.forEach($scope.subjectsNotOnDiploma, function(subjectNoD){
                                     if( subjectNoD.subjectName != null && subjectNoD.subjectName!= undefined && subjectNoD.subjectName)                                    
                                        $scope.forms.CoursesNotCounted['subjectNoD_'+index].$setValidity('subjectRequired', true);
                                    
                                    else
                                        $scope.forms.CoursesNotCounted['subjectNoD_'+index].$setValidity('subjectRequired', false);
                                    index= index +1;

                             });
                        }
                        $scope.validationList=[];
                        if ($scope.forms.Subjects.$dirty){
                            var index = 0;
                            $scope.validationList.push(false);
                            angular.forEach($scope.subjectList, function(subject){
                                if(angular.isDefined(subject.subSubjects)){
                                    var indJ =0;
                                    angular.forEach(subject.subSubjects, function (subsubject){
                                            var indK = 0;
                                             angular.forEach(subsubject.stuGPCourse, function (course){
                                                        if( course.subjectName != null && course.subjectName!= undefined && course.subjectName){
                                                            $scope.forms.Subjects['subject_'+index+'_'+indJ+'_'+indK].$setValidity('subjectRequired', true);
                                                        }else{       
                                                            $scope.forms.Subjects['subject_'+index+'_'+indJ+'_'+indK].$setValidity('subjectRequired', false);
                                                            $scope.validationList[index]=true;
                                                        }
                                                        indK = indK +1;
                                            });
                                            indJ = indJ +1;
                                    });
                                 }else {
                                    var indJ = 0;
                                    angular.forEach(subject.stuGPCourse, function(course){
                                        if( course.subjectName != null && course.subjectName!= undefined && course.subjectName){
                                            $scope.forms.Subjects['subject_'+index+'_'+indJ].$setValidity('subjectRequired', true);
                                        }
                                         else{
                                             $scope.forms.Subjects['subject_'+index+'_'+indJ].$setValidity('subjectRequired', false);
                                             $scope.validationList[index]=true;

                                         }
                                        indJ = indJ +1;
                                    });    
                                 }
                                
                                index= index +1;

                            });

                        }
                        checkFormValidations();
                        if($scope.forms.CoursesNotCounted.$valid && $scope.forms.Subjects.$valid){
                            var listRequest=[];
                             angular.forEach(editedCourseList, function(course){
                                listRequest.push(course);
                             });
                            editStuGradPlanBySubject(listRequest);
                        }

                    }

                    $scope.getRetroChangeIndicator = function(isSave){

                        $scope.indicator =0 ;   
                        var dateTime = "";
                        if(isSave){
                            dateTime = graduationPlanSvc.date;
                        }
                        $http({
                            url: schoolwork12.app.student.endpoints.studentEdit + $scope.studentRow.entity.studentId + '/retro/gradplan/' + $scope.gpHeader.studentGradPlanId+ '/schoolId/'+ $scope.studentRow.entity.schoolId,  
                            method : "GET",
                            headers : {
                                        'X-API-TOKEN': authentication.getCurrentUser().keycode
                                    },
                            params: {
                                        isSave : isSave,
                                        dateTime : dateTime
                                    }
                        }).then(function(response){       
                            console.info("Retro Change Indicator");
                            $scope.indicator = response.data;
                            saveGradPlan();                                

                        }, function(error){
                            console.info('Error getting Retro Change Indicator...'.concat(angular.toJson(error)));
                             $scope.editGradBySubjectErrorOccurred = true;
                             $scope.getGradSubErrorMesg = "";

                            if (error.status == 400) {
                                $scope.stuGradPlanSuccess = false;
                                for (var j = 0; j < error.data._errors.length; j++) {
                                    $scope.getGradSubErrorMesg = $scope.getGradSubErrorMesg + error.data._errors[j] + "\n";
                                }
                            } else if (error.status == 401 || error.status == 403) {
                                $scope.getGradSubErrorMesg = schoolwork12.app.errorMessages.sessionExpired;
                            } else {
                                $scope.getGradSubErrorMesg = schoolwork12.app.errorMessages.internalError;
                            } 
                            
                        });
                                               
                    }

                    var openAlertRetroChanges = function(){
                         $scope.saveRetroIndicator = $uibModal.open({
                            animation: $scope.animationsEnabled,
                            templateUrl: 'saveRetroIndicator.html',
                            keyboard: false,
                            backdrop: 'static',
                            scope: $scope,
                            size:'lg',
                            controller: ['$scope', '$uibModalInstance',
                            function ($scope, $uibModalInstance) {
     
                                    $scope.return = function () {
                                        $uibModalInstance.close(1);


                                    };
                                    $scope.continue = function () {
                                        
                                        $uibModalInstance.close(2);
                                    };

                                    $scope.getAuditTrailFromRetro = function (){
                                        $uibModalInstance.close(3);
                                        $scope.showAuditTrailModal();
                                    };

                                }], 
                                
                            });
                    }

                    var saveGradPlan = function(){
                         $scope.showSavedStudentMsg = false;
                        if($scope.indicator>0) {
                            openAlertRetroChanges(); 
                            $scope.saveRetroIndicator.result.then(function (option) {
                                if(option==1){//return to view
                                    if($scope.forms.CoursesNotCounted.$dirty || $scope.forms.Subjects.$dirty){
                                        $scope.subjectsNotOnDiploma= angular.copy ($scope.subjectsNotOnDiplomaSnapshot) ;
                                        $scope.subjectList= angular.copy ($scope.subjectListSnapShot) ;
                                        $scope.option2=false;
                                        initializeFormValidations();
                                        editedCourseList = [];
                                        $scope.forms.CoursesNotCounted.$setPristine();
                                        $scope.forms.Subjects.$setPristine();
                                        $scope.forms.postHSSubject.$setPristine();
                                        $scope.disableEditMode();
                                    }
                                }/*else if(option==2){//save grad plan
                                       $scope.saveGradPlanEditBySubject();
                                }*/ //STT-7909 dont allow editing if changes are in progress
                            });
                        }else {
                             $scope.saveGradPlanEditBySubject();
                        }
                        
                    }

                    var editStuGradPlanBySubject = function(listRequest){
                            console.log("Saving edit subject view ");

                            $scope.isSaveStuPlanBySubjectBusy = true;
                            $scope.studentRow.entity.editCompleted = false;
                            $scope.savePlanSuccess = false;
                            let additionalParams = "";
                            const postHS = {postHsPlansId: $scope.postHSSubjectData.selectedHSPlan || 0, postHsPlansDetails: $scope.postHSSubjectData.text || ""};
                            additionalParams = new URLSearchParams(postHS).toString();

                            $http({
                                url: schoolwork12.app.student.endpoints.studentEdit + $scope.studentRow.entity.studentId +'/gradplan/' + $scope.gpHeader.studentGradPlanId + '/school/'+ $scope.studentRow.entity.schoolId +'/diploma/'+$scope.gpHeader.diplomaId+'/'+ $scope.readyForStudentViewDisplay.valueEdit + '?' + additionalParams,  
                                method : "PUT",
                                headers : {
                                    'Content-Type': 'application/json',
                                    'X-API-TOKEN': authentication.getCurrentUser().keycode
                                },
                                data: listRequest
                            }).then(function(response){       
                                console.info("Viewing student graduation plan by Subject");
                                $scope.getStudentGradPlanBySubject();
                                $scope.forms.Subjects.$setPristine();
                                $scope.forms.CoursesNotCounted.$setPristine();
                                $scope.forms.postHSSubject.$setPristine();


                                $scope.disableEditMode();
                                $scope.showSavedStudentMsg = true;
                                $scope.isSaveStuPlanBySubjectBusy = false;
                                $scope.studentRow.entity.editCompleted = true;
                                $rootScope.saveBySubjectPlanSuccess = true;
                                $scope.savePlanSuccess = true;
                                
                                $scope.isStuGradPlanSubSpinnerActive = false;
                                editedCourseList=[];
                            }, function(error){
                                console.info('Error in editing graduation plan...'.concat(angular.toJson(error)));
                                $scope.isStuGradPlanSubSpinnerActive = false;
                                $scope.showSavedStudentMsg = false;
                                $scope.isSaveStuPlanBySubjectBusy = false;
                                $scope.studentRow.entity.editCompleted = false; 
                                $scope.editGradBySubjectErrorOccurred = true;
                                $scope.getGradSubErrorMesg = "";

                                if (error.status == 400) {
                                    for (var j = 0; j < error.data._errors.length; j++) {
                                        $scope.getGradSubErrorMesg = $scope.getGradSubErrorMesg + error.data._errors[j] + "\n";
                                    }
                                } else if (error.status == 401 || error.status == 403) {
                                    $scope.getGradSubErrorMesg = schoolwork12.app.errorMessages.sessionExpired;
                                } else {
                                    $scope.getGradSubErrorMesg = schoolwork12.app.errorMessages.internalError;
                                }  
                            })
                    }

                    var subjectFromMap = function(schoolSubjectId,k12SubjectId){
                            var schSubjectId = angular.isDefined(schoolSubjectId) ? "schSubjectId"+schoolSubjectId : null;
                            var k12SubjectId = angular.isDefined(k12SubjectId) ? "k12SubjectId"+k12SubjectId : null;
                            var subject = {};
                            if(angular.isDefined($scope.subjectMap[schSubjectId])){
                                subject = $scope.subjectMap[schSubjectId];
                            }
                            if(angular.isDefined($scope.subjectMap[k12SubjectId])){
                                subject = $scope.subjectMap[k12SubjectId];
                            }
                            return subject;
                        }

                    var getGradefromStatus = function(course){
                        if(course.completionStatusId==0)
                            course.gradeMark = 'Not Started';
                        if(course.completionStatusId==1)
                            course.gradeMark = 'In Progress';
                         return course.gradeMark;
                    }

                    var sortSubject = function(a, b) {
                        if((a.subjectName == "" || b.subjectName == "") && !(a.subjectName == ""&&b.subjectName == "")){
                            if(a.subjectName=="")
                                return 1;
                            else 
                                return -1;
                        }
                        if(a.subjectName == b.subjectName){
                            return courseSort(a,b);
                        }
                        if(a.subjectName > b.subjectName){
                            return 1;
                        }
                        if(a.subjectName < b.subjectName){
                            return -1;
                        }
                    }
                    
                    var courseSort = function(a, b) {                       
                        if(a.courseName == "Not Specified" || b.courseName == "Not Specified"){                                                   if(a.courseName == "Not Specified") return 1;
                            else return -1;
                        }
                        else{
                            return a.courseName > b.courseName ? 1 : -1;
                        }                        
                    }

                     var getSubjectFromList = function(schoolSubjectId){
                           
                         var sub= {};
                         angular.forEach($scope.subjectFields2, function(subject){
                                if (schoolSubjectId == subject.schoolSubjectId){
                                    sub = subject;
                                  return sub;  
                                } 
                         });
                         return sub;
                    }

                    var initializeFormValidations = function(){
                        $scope.validateCoursesNoC = false;
                        $scope.validateSubjects = false;
                        $scope.validationList=[];

                    }

                    var checkFormValidations = function(){
                        //add error styles based on validation flags
                        $scope.validateCoursesNoC = !$scope.forms.CoursesNotCounted.$valid ? true : false;
                        $scope.validateSubjects = !$scope.forms.Subjects.$valid ? true : false;
                    }

                    $scope.onChangeHSPlanSubject = (shouldUpdatePlaceholderStatus) =>{
                        const selectedPlan = $scope.HSPlanList.find(plan=>plan.id === $scope.postHSSubjectData.selectedHSPlan);
                        const name = selectedPlan? selectedPlan.name : '';
                        $scope.postHSSubjectData.HSPlaceholder = $scope.getPostHSPlaceholder(name);
                        
                        if(shouldUpdatePlaceholderStatus)
                            $scope.changesHsPlaceholderSubject();
                       };

                       $scope.changesHsPlaceholderSubject = () =>{
                        if ($scope.forms.postHSSubject)
                            $scope.forms.postHSSubject.$setDirty();
                       }
                    
            }
        ]);   
}(angular, schoolwork12));
